module.exports = {"220323100":"伊通镇","220323101":"二道镇","220323102":"伊丹镇","220323103":"马鞍镇","220323104":"景台镇","220323105":"靠山镇","220323106":"大孤山镇","220323107":"小孤山镇","220323108":"营城子镇","220323109":"西苇镇","220323110":"河源镇","220323111":"黄岭子镇","220323200":"新兴乡","220323201":"莫里青乡","220323202":"三道乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220323.json
// module id = 577
// module chunks = 0